// extracted by mini-css-extract-plugin
module.exports = {"page":"Oasis_page__h_k78"};